var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('calibration-page',{attrs:{"rg-id":_vm.rgId,"is-manage-mode":true}})}
var staticRenderFns = []

export { render, staticRenderFns }